import { createBrowserHistory } from "history";

export const customHistory = createBrowserHistory({ basename: process.env.REACT_APP_BASENAME});
